
import { Component, Vue } from 'vue-property-decorator';
import { NationalEventsInterface } from '@/services/Calendar/NationalEvents/Interfaces';
import { EventsInterface } from '@/services/Calendar/Events/Interfaces';
import EventsComponent from '@/views/pages/calendar/events/components/EventsComponent.vue';
import EventsRepository from '@/services/Calendar/Events';
import NationalEventsComponent from '@/views/pages/calendar/events/components/NationalEventsComponent.vue';
import NationalEventsRepository from '@/services/Calendar/NationalEvents';
import RepeatableEventsComponent from '@/views/pages/calendar/events/components/RepeatableEventsComponent.vue';
import RepeatableEventsRepository from '@/services/Calendar/RepeatableEvents';
import { RepeatableEventsInterface } from "@/services/Calendar/RepeatableEvents/Interfaces";
import { BaseProfileDataInterface, ProfileRepositoryInterface } from "@/services/Users-profile/interfaces";
import PageHeader from '@/components/layout/PageHeader.vue';

@Component({
  components: {
    EventsComponent,
    RepeatableEventsComponent,
    NationalEventsComponent,
    PageHeader,
  },
  inject: [
    'profileRepository',
    'eventsRepository',
    'nationalEventsRepository',
    'repeatableEventsRepository',
  ],
})
export default class Manage extends Vue {
  private readonly eventsRepository!: EventsRepository;
  private readonly nationalEventsRepository!: NationalEventsRepository;
  private readonly repeatableEventsRepository!: RepeatableEventsRepository;

  private events: EventsInterface[] = [];
  private nationalEvents: NationalEventsInterface[] = [];
  private repeatableEvents: RepeatableEventsInterface[] = [];
  private profileRepository!: ProfileRepositoryInterface;
  private usersMap: { [userId: string]: BaseProfileDataInterface } = {};

  private loading: boolean = false;

  public async mounted(): Promise<void> {
    this.loading = true;
    await this.getEvents();
    await this.getRepeatableEvents();
    await this.getNationalEvents();
    await this.getUserDetails();
    this.loading = false;
  }

  private async getUserDetails(): Promise<void> {
    const usersIds: string[] = [];
    this.events.forEach((event) => {
      if (event.author) {
        usersIds.push(event.author);
      }
    });
    this.repeatableEvents.forEach((event) => {
      if (event.author) {
        usersIds.push(event.author);
      }
    });
    const profiles = await this.profileRepository.getBaseProfileDataByUsersIds(usersIds);
    profiles.forEach((profile) => {
      this.usersMap[profile.userId] = profile;
    });
  }

  private async getEvents(): Promise<void> {
    this.events = await this.eventsRepository.getAllEventsForCurrentYear();
    this.events = this.events.map((event) => {
      if (event.date) {
        event.date = new Date(event.date);
      }

      return event;
    });
  }

  private async getRepeatableEvents(): Promise<void> {
    this.repeatableEvents = await this.repeatableEventsRepository.getAllRepeatableEvents();
    this.repeatableEvents = this.repeatableEvents.map((event) => {
      if (event.date) {
        event.date = new Date(event.date);
      }

      return event;
    });
  }

  private async getNationalEvents(): Promise<void> {
    this.nationalEvents = await this.nationalEventsRepository.getAllNationalEvents();
    this.nationalEvents = this.nationalEvents.map((event) => {
      if (event.date) {
        event.date = new Date(event.date);
      }

      return event;
    });
  }

  private filterEvents(id: number): void {
    this.events = this.events.filter((event) => {
      return event.id !== id;
    });
  }

  private filterRepeatableEvents(id: number): void {
    this.repeatableEvents = this.repeatableEvents.filter((event) => {
      return event.id !== id;
    });
  }

  private filterNationalEvents(id: number): void {
    this.nationalEvents = this.nationalEvents.filter((event) => {
      return event.id !== id;
    });
  }
}
